import React from "react";
import { NumericFormat } from "react-number-format";
import ProgressBar from "../ProgressBar";
import Ballot from "./Ballot";
import "./ballot-card.scss";
import "./universal-widget.scss";

import { ReactComponent as CollapseIcon } from "../images/icon-collapse_latest.svg";
import { ReactComponent as ExpandIcon } from "../images/icon-expand_latest.svg";
import { getOverride, getEstimatedVotesPercent } from "../helpers";

const BallotCard = React.memo(({
  ballot,
  widget: options,
  onToggle,
  expanded
}) => {

  const name = getOverride(ballot, "name");
  const description = getOverride(ballot, "description");
  const filteredDescription = description && description.split('#')[0];
  const precinctsReporting = getOverride(ballot, "precinctsReporting");
  const precinctsTotal = getOverride(ballot, "precinctsTotal");
  const votesCast = getOverride(ballot, "votesCast");

  const thereIsAWinner =
    ballot.candidates.some(candidate => getOverride(candidate, "winner") === true) &&
    options.showWinner;

  // AP estimated expected vote percentage (eevp), whole number or null when blank. Never calculated; precinctsPercent is not used.
  const reportingPercentage = getEstimatedVotesPercent(ballot);
  const hasPercent = reportingPercentage !== null;

  // Hide the precinct reporting block entirely when there is no precinct data.
  const hasPrecinctData = Number(precinctsTotal) > 0;
  const showPrecincts = options.showPrecincts && hasPrecinctData;

  return (
    <div>
      <div
        className={
          "widget race" +
          (showPrecincts ? "" : " no-precincts") +
          (expanded ? " expanded" : " collapsed")
        }
      >
        <div
          className="ballot-title"
          onClick={onToggle}
        >
          <div className="ballot-title-name">
            <span>{name}</span>
          </div>
          {expanded ? (
            <ExpandIcon className="expand-icon" title="Expand" />
          ) : (
            <CollapseIcon className="expand-icon" title="Collapse" />
          )}
        </div>
        {description && filteredDescription && (
          <div className="ballot-description">
            <p>{filteredDescription}</p>
          </div>
        )}
        <div className="ballot-cards">
          <Ballot
            votes={ballot.candidates}
            options={options}
            votesCast={votesCast}
            thereIsAWinner={thereIsAWinner}
          />
          <div
            className={
              "grid-row totals" +
              (options.showPercentOfVotes ? "" : " no-percentage")
            }
          >
            <div className="ballot-total-label">Total</div>
            <div className="ballot-total-votes">
              <NumericFormat
                value={votesCast}
                displayType={"text"}
                thousandSeparator={true}
              />{" "}
              votes
            </div>
          </div>
        </div>
        {showPrecincts && (
          <div
            className={
              "ballot-precincts-reporting" +
              (options.showPercentOfPrecincts ? "" : " no-percent-precincts")
            }
          >
            {options.showPercentOfPrecincts && hasPercent && (
              <div className="grid-row progress-bar-and-percentage-container">
                <div></div>
                <div className="progress-bar-with-percentage">
                  <ProgressBar
                    percentage={reportingPercentage}
                  />
                </div>
                <div className="race-precincts-reporting-percentage progress-bar-percentage">
                  {reportingPercentage}%
                </div>
              </div>
            )}
            {options.showTotalPrecincts && (
              <div className="ballot-precincts-reporting-text">
                <NumericFormat
                  value={precinctsReporting}
                  displayType={"text"}
                  thousandSeparator={true}
                />{" "}
                of{" "}
                <NumericFormat
                  value={precinctsTotal}
                  displayType={"text"}
                  thousandSeparator={true}
                />{" "}
                Precincts Reporting
              </div>
            )}
            {!options.showTotalPrecincts && (
              <span>Precincts Reporting</span>
            )}
          </div>
        )}
      </div>
    </div>
  );
});

export default BallotCard;
